import React, { useState } from 'react';
import MainLayout from '../Layouts/MainLayout';
import RenewalCheckout from './RenewalCheckout';

function RenewalCheckoutContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: 'Renewal Checkout',
    navSubTitle: 'Welcome to ImagesBazaar',
  });
  return (
    <MainLayout
      navTitle={navParams.navTitle}
      navSubTitle={navParams.navSubTitle}
    >
      <RenewalCheckout />
    </MainLayout>
  );
}

export default RenewalCheckoutContainer;
